import React, { useEffect, useState } from 'react';
import DocumentAutoComplete from "containers/protocol/components/DocumentAutoComplete"
import { MUITextBox, ReactFormSelect } from 'components/FormHelpers/FormInputs';
import { getEmptyValue, getUIDateFormat, useCtxParseValue } from 'helpers';
import _ from 'lodash';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';

export const cancelModal = (onCloseModal) => {
    onCloseModal();
}

export const handleKeyDown = (eve, state, setState) => {
  setState({
    ...state,
    protocolNumber: eve.target.value.toUpperCase()
  })
}

export const handleInputSugessionChange = (val, suggestions, setSuggestions, ReqOptions) => {
    if (val) {
      setSuggestions(_.filter(suggestions,
        (item) => item.value.toLowerCase().includes(val.toLowerCase())));
    } else {
      setSuggestions(ReqOptions);
    }
  };

export const ProtAutoComplete = ({
    handleInputChange
}) => {
    return <DocumentAutoComplete onChange={
      (prot) => {
        handleInputChange(prot)
    }
  }/>;
};

export const ProtNumber = ({ state, setState, handleChange }) => (
    <MUITextBox
      title="Protocol Number"
      inputClassName="protNumber-unregistered-study"
      value={getEmptyValue(state && state.protocolNumber)}
      validators={['required']}
      errorMessages={['Protocol Number is required']}
      onChange={handleChange}
      onKeyUp={(eve) => handleKeyDown(eve, state, setState)}
      name="protocolNumber"
    />
  );

  export const ProtTitle = ({ state, handleChange }) => (
    <MUITextBox
      title="Protocol Title"
      value={getEmptyValue(state && state.title)}
      onChange={handleChange}
      validators={['required']}
      errorMessages={['Protocol Title is required']}
      name="title"
    />
  );

  export const LeadGroup = ({ state, handleSelChange }) => {
    const { protocolAgentGroup } = useCtxParseValue('LOV_AGENT_GROUP');
    const ReqOptions = _.map(protocolAgentGroup,
        (item) => {
            return { label: item, value: item }
        });
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [leadGrp, selLeadGrp] = useState(null);
  
    useEffect(() => {
      if (state) {
        selLeadGrp(_.find(suggestions, (item) => state.leadGrp === item.value));
      } else {
        selLeadGrp({});
      }
    }, [selLeadGrp, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="Lead Group"
        name="leadGrp"
        options={suggestions}
        value={leadGrp || ''}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selLeadGrp, 'leadGrp')}
      />
    );
  };

  export const GroupProtStatus = ({ state, handleSelChange }) => {
    const { protocolStsCanGoto } = useCtxParseValue('LOV_PROTOCOL_STATUS_GOTO');
    protocolStsCanGoto.push({ from_state: 'FDAAA/IRB Completed', to_state: [] });
    const ReqOptions = _.map(protocolStsCanGoto,
        (item) => {
            return { label: item.from_state, value: item.from_state }
        });
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [grpProtStatus, selGrpProtStatus] = useState(null);
  
    useEffect(() => {
      if (state) {
        selGrpProtStatus(_.find(suggestions, (item) => state.grpProtStatus === item.value));
      } else {
        selGrpProtStatus({});
      }
    }, [selGrpProtStatus, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="Lead Group"
        name="grpProtStatus"
        options={suggestions}
        value={grpProtStatus || ''}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selGrpProtStatus, 'grpProtStatus')}
      />
    );
  };

  export const GrpProtStatusDate = ({
    state, handleDateChange
  }) => {
    return (
      <MUIDatePicker
        title="Group Protocol Status Date"
        name="grpProtStatusDate"
        onChange={handleDateChange('grpProtStatusDate')}
        value={(state && state.grpProtStatusDate) ? getUIDateFormat(state.grpProtStatusDate) : ''}
        popperPlacement="top-start"
      />
    );
  };

  export const ActivatedOn = ({
    state, handleDateChange
  }) => {
    return (
      <MUIDatePicker
        title="Activated On"
        name="activatedDate"
        onChange={handleDateChange('activatedDate')}
        value={(state && state.activatedDate) ? getUIDateFormat(state.activatedDate) : ''}
        popperPlacement="top-start"
      />
    );
  };

  export const MatchBox = ({ state, handleSelChange }) => {
    const ReqOptions = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [isMatchboxStudy, selMatchboxStudy] = useState(null);
  
    useEffect(() => {
      if (state) {
        selMatchboxStudy(_.find(suggestions, (item) => state.isMatchboxStudy === item.value));
      } else {
        selMatchboxStudy({});
      }
    }, [selMatchboxStudy, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="MATCHBox Protocol?"
        name="isMatchboxStudy"
        options={suggestions}
        value={isMatchboxStudy || false}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selMatchboxStudy, 'isMatchboxStudy')}
      />
    );
  };

  export const Comments = ({
    state, handleChange
  }) => (
    <MUITextBox
      multiline
      rowsMax="2"
      value={getEmptyValue(state && state.comments)}
      onChange={handleChange}
      validators={['maxStringLength:500']}
      errorMessages={['Maximum 500 characters allowed']}
      name="comments"
      title="Internal Comments"
    />
  );

  export const OpenProtocol = ({ state, handleSelChange }) => {
    const ReqOptions = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [isEnrollThruOpen, selEnrollThruOpen] = useState(null);
  
    useEffect(() => {
      if (state) {
        selEnrollThruOpen(_.find(suggestions, (item) => state.isEnrollThruOpen === item.value));
      } else {
        selEnrollThruOpen({});
      }
    }, [selEnrollThruOpen, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="OPEN Protocol?"
        name="isEnrollThruOpen"
        options={suggestions}
        value={isEnrollThruOpen || false}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selEnrollThruOpen, 'isEnrollThruOpen')}
      />
    );
  };

  export const OpenLoadToRave = ({ state, handleSelChange }) => {
    const ReqOptions = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [isOpenLdRave, selOpenLdRave] = useState(null);
  
    useEffect(() => {
      if (state) {
        selOpenLdRave(_.find(suggestions, (item) => state.isOpenLdRave === item.value));
      } else {
        selOpenLdRave({});
      }
    }, [selOpenLdRave, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="OPEN to Load to Rave?"
        name="isOpenLdRave"
        options={suggestions}
        value={isOpenLdRave || false}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selOpenLdRave, 'isOpenLdRave')}
      />
    );
  };

  export const OpenSlotReservation = ({ state, handleSelChange }) => {
    const ReqOptions = [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }];
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [isSlotReservation, selSlotReservation] = useState(null);
  
    useEffect(() => {
      if (state) {
        selSlotReservation(_.find(suggestions, (item) => state.isSlotReservation === item.value));
      } else {
        selSlotReservation({});
      }
    }, [selSlotReservation, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="OPEN Slot Reservation"
        name="isSlotReservation"
        options={suggestions}
        value={isSlotReservation || false}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selSlotReservation, 'isSlotReservation')}
      />
    );
  };

  export const Step = ({ state, handleChange }) => (
    <MUITextBox
      title="Step"
      validators={['required']}
      errorMessages={['Step is required']}
      value={getEmptyValue(state && state.step)}
      onChange={handleChange}
      name="step"
      type="number"
    />
  );

  export const RelationType = ({ state, handleSelChange }) => {
    const ReqOptions = [{
        label: 'Embedded',
        value: 'Embedded'
      }, {
        label: 'Standalone',
        value: 'Standalone'
      }];
    const [suggestions, setSuggestions] = useState(ReqOptions);
    const [relationType, selRelationType] = useState(null);
  
    useEffect(() => {
      if (state) {
        selRelationType(_.find(suggestions, (item) => state.relationType === item.value));
      } else {
        selRelationType({
          label: 'Standalone',
          value: 'Standalone'
        });
      }
    }, [selRelationType, suggestions, state]);
  
    return (
      <ReactFormSelect
        title="Relation"
        name="relationType"
        options={suggestions}
        value={relationType}
        onInputChange={(val) => handleInputSugessionChange(val, suggestions, setSuggestions, ReqOptions)}
        onChange={(eve) => handleSelChange(eve, selRelationType, 'relationType')}
      />
    );
  };